/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
// @mui
import {
  Card,
  Container,
  Table,
  TableContainer,
  TablePagination
} from '@mui/material';
// components
import Scrollbar from '@src/components/scrollbar';
// mock
import DataTableRow from '@src/components/data-table/data-row';
import { TABLE_HEAD_RAFFLE_DRAW } from '@src/utils/mockdata/table-headers';
import _ from 'lodash';
import BodyHeader from './body-header';
import CreateDialog from './create-dialog';
import EditDialog from './edit-dialog';
import { useService } from './hooks';
import { useRaffleDrawContext } from './provider';
import TableHeader from './table-header';
import TableRowItem from './table-row';
import ViewWinners from './view-winners';

const Body = () => {
  const { data, lists, isLoading, onRefresh } = useService();
  const { state, viewWinners, handlePageChange, handleRequestSort, 
    handleRowsPerPageChange, openEdit, setViewWinners } = useRaffleDrawContext();

  return (
    <Container>
      <BodyHeader />
      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800, p:2 }}>
            <Table>
              <TableHeader
                disableButton
                order={state.order}
                orderBy={state.orderBy}
                headLabel={TABLE_HEAD_RAFFLE_DRAW}
                onRequestSort={handleRequestSort}
              />
              <DataTableRow
                colSpan={8}
                isLoading={isLoading}
                headers={TABLE_HEAD_RAFFLE_DRAW}
                data={lists}
                renderItem={({ item, index }: any) => {
                  return <TableRowItem 
                    key={`${index}`} {...item} 
                    refresh={onRefresh}
                    onViewWinners={setViewWinners}
                    onOpenEdit={openEdit} />
                }} />
            </Table>
          </TableContainer>
        </Scrollbar>
        <TablePagination
          page={state.page || 0}
          component="div"
          rowsPerPage={state.rowsPerPage || 10}
          count={data?.totalRecords ?? 0}
          onPageChange={handlePageChange}
          rowsPerPageOptions={[10, 20, 50]}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </Card>
      {!_.isEmpty(state.editDetails) && <EditDialog />}
      {state.openCreate && <CreateDialog />}
      {!_.isEmpty(viewWinners) && <ViewWinners />}
    </Container>
  );
}

export default React.memo(Body);
